import { styled } from '@mui/material';
import ProductForm, {
  TProductFormType,
  IProductFormValues,
} from 'FeatureModules/ProductPage/Components/Forms/ProductForm';
import { DialogDefault } from 'DesignSystem';
import React, { FC, useMemo } from 'react';
import { IDefaultDialogProps } from 'types/dialog.types';
import useCreateProduct from 'FeatureModules/ProductPage/hooks/useCreateProduct';
import { StyledDialogContent, TopBackground } from '../Create/styles';
import useProductActions from 'FeatureModules/ProductPage/hooks/useProductActions';

const StyledDialog = styled(DialogDefault)(({ theme }) => ({
  '& .MuiPaper-root:not(.MuiAlert-root)': {
    maxWidth: '750px',
  },
}));

export type IAddDuplicateEditProductDialogProps = IDefaultDialogProps & TProductFormType;

const AddDuplicateEditProductDialog: FC<IAddDuplicateEditProductDialogProps> = ({
  open,
  product,
  action,
  onClose,
}) => {
  const { onDuplicate, onCreate } = useCreateProduct();
  const { handleUpdateProduct } = useProductActions();

  const dialogConfig = useMemo(() => {
    switch (action) {
      case 'CREATE':
        return {
          title: 'Add new product',
          submitButtonText: 'Continue',
          onSubmit: (values: IProductFormValues) => onCreate(values),
        };
      case 'DUPLICATE':
        return {
          title: `Duplicate ${product.title}`,
          submitButtonText: 'Duplicate',
          onSubmit: (values: IProductFormValues) => onDuplicate({ id: product.id, ...values }),
        };
      case 'EDIT':
        return {
          title: 'Edit product page',
          submitButtonText: 'Save changes',
          onSubmit: (values: IProductFormValues) => handleUpdateProduct(product.id, values),
        };
      default:
        throw new Error(`Invalid action: ${action}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action]);

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      title={dialogConfig.title}
      maxWidth="md"
      data-testid="create-product-dialog"
    >
      <TopBackground />
      <StyledDialogContent>
        {/* @ts-ignore Type can not be resolved correctly */}
        <ProductForm
          action={action}
          product={product}
          submitButtonText={dialogConfig.submitButtonText}
          onSubmit={dialogConfig.onSubmit}
        />
      </StyledDialogContent>
    </StyledDialog>
  );
};

export default AddDuplicateEditProductDialog;
